import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"fill-color-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3.58788 14.1215L9.87886 20.4125C11.0504 21.584 12.9499 21.584 14.1215 20.4125L21.5342 12.9998H2.87988C3.02427 13.4094 3.26027 13.7939 3.58788 14.1215Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 8L5.99996 2M21 13H3.49996M12 1.4668L22.5336 12.0004L14.1213 20.4127C12.9497 21.5843 11.0502 21.5843 9.87864 20.4127L3.58766 14.1217C2.41609 12.9502 2.41609 11.0507 3.58766 9.8791L12 1.4668Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21.2197 22.0095C21.5126 22.3795 21.9874 22.3795 22.2803 22.0095C22.5732 21.6396 22.5732 21.0398 22.2803 20.6698L21.75 20L21.2197 20.6698C20.9268 21.0398 20.9268 21.6396 21.2197 22.0095Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FillColor1 = Vue.extend<IconProps>({
  name: 'FillColor1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'fill-color-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FillColor1;
